module.exports = __webpack_public_path__ + "static/media/notfound-image.5258d3f7.jpg";